var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('Map'),(!_vm.introDismissed)?_c('Intro'):_vm._e(),_c('SidePanel',[_c('router-view')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }